import { render, staticRenderFns } from "./roi.form.vue?vue&type=template&id=bff7d3e0&"
import script from "./roi.form.vue?vue&type=script&lang=js&"
export * from "./roi.form.vue?vue&type=script&lang=js&"
import style0 from "./roi.form.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../../../tmp/ffsecurity-ui/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports